import { render, staticRenderFns } from "./AppointmentEvents.vue?vue&type=template&id=23dc77be&scoped=true&"
import script from "./AppointmentEvents.vue?vue&type=script&lang=js&"
export * from "./AppointmentEvents.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentEvents.vue?vue&type=style&index=0&id=23dc77be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc77be",
  null
  
)

export default component.exports